import { render, staticRenderFns } from "./Estadisticas.vue?vue&type=template&id=2f85e7c4&scoped=true"
import script from "./Estadisticas.vue?vue&type=script&lang=js"
export * from "./Estadisticas.vue?vue&type=script&lang=js"
import style0 from "./Estadisticas.vue?vue&type=style&index=0&id=2f85e7c4&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85e7c4",
  null
  
)

export default component.exports